// extracted by mini-css-extract-plugin
export default {"root":"OrganicResultsActions_root__XEyb6","hasBrandRow":"OrganicResultsActions_hasBrandRow__pAbvB","buttonsRow":"OrganicResultsActions_buttonsRow__CZp0n"};